import React from 'react';
import Popover from '@material-ui/core/Popover';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { InfoOutlined as InfoOutlinedIcon } from "components/MaterialSymbol/MaterialIcons"; // Importa el ícono

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: 'none',
    },
    paper: {
        padding: theme.spacing(1),
        maxWidth: 300
    },
    button: {
        width: 28,
        height: 28,
        padding: 0,
        marginLeft: 5,
        borderRadius: 999,
        backgroundColor: "#111827",
        color: "#ffffff",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#1F2937",
            boxShadow: "none",
        },
    },
    icon: {
        fontSize: 18,
        color: "#ffffff",
    },
}));

export default function InfoButton({ title = "WHAT'S THIS?", description = "", ...otherProps }) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handlePopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);

    return (
        <div {...otherProps}>
            <IconButton
                aria-owns={open ? 'mouse-over-popover' : undefined}
                aria-haspopup="true"
                className={classes.button}
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                <InfoOutlinedIcon className={classes.icon} />
            </IconButton>
            <Popover
                id="mouse-over-popover"
                className={classes.popover}
                classes={{
                    paper: classes.paper,
                }}
                open={open}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
            >
                <Typography variant="h6" gutterBottom style={{ fontSize: 15, fontWeight: 'bold' }}>
                    {title}
                </Typography>
                <Typography gutterBottom style={{ textAlign: 'justify' }}>
                    {description}
                </Typography>
            </Popover>
        </div>
    );
}
